// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter_tab_item_M9LeglCX .tabs_uT2maQ4h {\n  margin-bottom: 8px;\n}\n", "",{"version":3,"sources":["webpack://./public/views/filter/components/filterTabItem.vue","webpack://./filterTabItem.vue"],"names":[],"mappings":"AACA;EAEI,kBAAA;ACDJ","sourcesContent":["\n.filter_tab_item {\n  .tabs {\n    margin-bottom: 8px;\n  }\n}\n",".filter_tab_item .tabs {\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter_tab_item": "filter_tab_item_M9LeglCX",
	"tabs": "tabs_uT2maQ4h"
};
export default ___CSS_LOADER_EXPORT___;
